/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    calendarEvents: [
        {
            id: 1,
            title: 'My Event',
            start: '2019-04-16',
            end: '2019-04-17',
            desc: 'demo event',
            cssClass: 'event-danger',
            label: 'personal'
        },
    ],
    calendarLabels: [
        { text: '데스크' ,value : '데스크', color: 'success' },
        { text: '평일당직', value: '평일당직', color: 'warning'},
        { text: '주말공재', value: '주말공재', color: 'danger'},
        { text: '주말공현', value: '주말공현', color: 'primary'},
    ],
}
